import { router } from '@app/routes/Routes';
import { store } from '@app/store/store';
import { theme } from '@app/theme';
import { LoadingSpinner } from '@lib/components/feedback/LoadingSpinner';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<Suspense fallback={<LoadingSpinner />}>
					<RouterProvider router={router} />
				</Suspense>
				<ToastContainer
					position='top-right'
					autoClose={3000}
					hideProgressBar={false}
					newestOnTop
					closeOnClick
					pauseOnHover
				/>
			</ThemeProvider>
		</Provider>
	</StrictMode>
);
